"use strict";

var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HARIBOPhotoboothCell;
var _react = _interopRequireWildcard(require("react"));
var _qrcode = require("qrcode.react");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function HARIBOPhotoboothCell(_ref6) {
  var cell = _ref6.cell,
    screenType = _ref6.screenType,
    language = _ref6.language,
    project = _ref6.project,
    logEvent = _ref6.logEvent,
    page = _ref6.page,
    intl = _ref6.intl,
    _ref6$uriTransformer = _ref6.uriTransformer,
    uriTransformer = _ref6$uriTransformer === void 0 ? function (u) {
      return u;
    } : _ref6$uriTransformer;
  // Font constants
  var FONTS = {
    vag: 'VAGRundschriftD, Arial, sans-serif',
    default: 'Arial, sans-serif'
  };
  // Video source configuration - network stream from OBS
  var videoSource = 'stream';
  var streamUrl = "".concat(process.env.REACT_APP_HLS_BASE_URL || 'http://192.168.16.116:4000', "/stream/hls/stream.m3u8"); // Network stream URL

  // Step-based flow state
  var _ref7 = (0, _react.useState)('filter-selection'),
    _ref8 = _slicedToArray(_ref7, 2),
    step = _ref8[0],
    setStep = _ref8[1]; // 'filter-selection', 'preview', 'capture'
  var _ref9 = (0, _react.useState)(null),
    _ref0 = _slicedToArray(_ref9, 2),
    selectedFilter = _ref0[0],
    setSelectedFilter = _ref0[1];
  // Removed activeFrameId - we now disable all backgrounds before enabling new one

  // Countdown state
  var _ref1 = (0, _react.useState)(150),
    _ref10 = _slicedToArray(_ref1, 2),
    count = _ref10[0],
    setCount = _ref10[1]; // Countdown from 5 to 1
  var _ref11 = (0, _react.useState)(false),
    _ref12 = _slicedToArray(_ref11, 2),
    isCountingDown = _ref12[0],
    setIsCountingDown = _ref12[1];

  // Filter options data - these will trigger OBS source changes
  var filterOptions = [
  // Paris
  {
    id: 'paris_eiffel',
    name: 'Paris',
    obsScene: 'treeosk',
    // Keep for backward compatibility
    obsSources: {
      background: 'paris_city_background',
      text: 'city_text_paris',
      gummyBear: 'haribo_gummy_bear'
    },
    preview: uriTransformer('https://web-treeosk.online/apks/haribo_images/paris_eiffel_background.png'),
    borderColor: '#FF8C00' // Orange border
  },
  // Berlin
  {
    id: 'berlin_brandenburg',
    name: 'Berlin',
    obsScene: 'treeosk',
    // Keep for backward compatibility
    obsSources: {
      background: 'berlin_city_background',
      text: 'city_text_berlin',
      gummyBear: 'haribo_gummy_bear'
    },
    preview: uriTransformer('https://web-treeosk.online/apks/haribo_images/berlin_brandenburg_background.png'),
    borderColor: '#32CD32' // Green border
  },
  // Budapest
  {
    id: 'budapest_parliament',
    name: 'Budapest',
    obsScene: 'treeosk',
    // Keep for backward compatibility
    obsSources: {
      background: 'budapest_city_background',
      text: 'city_text_budapest',
      gummyBear: 'haribo_gummy_bear'
    },
    preview: uriTransformer('https://web-treeosk.online/apks/haribo_images/budapest_background.png'),
    borderColor: '#DC143C' // Red border
  },
  // Barcelona
  {
    id: 'barcelona_sagrada',
    name: 'Barcelona',
    obsScene: 'treeosk',
    // Keep for backward compatibility
    obsSources: {
      background: 'barcelona_city_background',
      text: 'city_text_barcelona',
      gummyBear: 'haribo_gummy_bear'
    },
    preview: uriTransformer('https://web-treeosk.online/apks/haribo_images/barcelona_background.png'),
    borderColor: '#4169E1' // Blue border
  }];

  // Component state
  var _ref13 = (0, _react.useState)(false),
    _ref14 = _slicedToArray(_ref13, 2),
    isInitialized = _ref14[0],
    setIsInitialized = _ref14[1];
  var _ref15 = (0, _react.useState)(true),
    _ref16 = _slicedToArray(_ref15, 2),
    loading = _ref16[0],
    setLoading = _ref16[1];
  var _ref17 = (0, _react.useState)(false),
    _ref18 = _slicedToArray(_ref17, 2),
    hasCamera = _ref18[0],
    setHasCamera = _ref18[1];
  var _ref19 = (0, _react.useState)(3),
    _ref20 = _slicedToArray(_ref19, 2),
    countdown = _ref20[0],
    setCountdown = _ref20[1];
  var _ref21 = (0, _react.useState)(null),
    _ref22 = _slicedToArray(_ref21, 2),
    capturedImage = _ref22[0],
    setCapturedImage = _ref22[1];
  var _ref23 = (0, _react.useState)(null),
    _ref24 = _slicedToArray(_ref23, 2),
    currentDataUri = _ref24[0],
    setCurrentDataUri = _ref24[1];
  var _ref25 = (0, _react.useState)(null),
    _ref26 = _slicedToArray(_ref25, 2),
    link = _ref26[0],
    setLink = _ref26[1];
  var _ref27 = (0, _react.useState)(''),
    _ref28 = _slicedToArray(_ref27, 2),
    email = _ref28[0],
    setEmail = _ref28[1];
  var _ref29 = (0, _react.useState)(false),
    _ref30 = _slicedToArray(_ref29, 2),
    emailSended = _ref30[0],
    setEmailSended = _ref30[1];
  var _ref31 = (0, _react.useState)(false),
    _ref32 = _slicedToArray(_ref31, 2),
    printed = _ref32[0],
    setPrinted = _ref32[1];
  var _ref33 = (0, _react.useState)(false),
    _ref34 = _slicedToArray(_ref33, 2),
    started = _ref34[0],
    setStarted = _ref34[1];
  var _ref35 = (0, _react.useState)(0),
    _ref36 = _slicedToArray(_ref35, 2),
    resultsStep = _ref36[0],
    setResultsStep = _ref36[1]; // Track which results step (0=options, 1=qr)

  // Refs
  var videoRef = (0, _react.useRef)(null);
  var canvasRef = (0, _react.useRef)(null);
  var countdownRef = (0, _react.useRef)(null);
  var reconnectTimeoutRef = (0, _react.useRef)(null);
  var reconnectAttempts = (0, _react.useRef)(0);
  var maxReconnectAttempts = 5;
  var reconnectDelay = 3000;

  // Load HLS.js library
  (0, _react.useEffect)(function () {
    if (!window.Hls) {
      var script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/hls.js@latest';
      script.onload = function () {};
      script.onerror = function () {};
      document.head.appendChild(script);
    }
  }, []);

  // Initialize video source only when in capture step
  (0, _react.useEffect)(function () {
    if (!isInitialized && step === 'capture') {
      initializeVideoSource();
      setIsInitialized(true);
    }
  }, [isInitialized, step]);
  var initializeVideoSource = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _t2;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            setLoading(true);
            _context.p = 1;
            _context.n = 2;
            return initializeStream();
          case 2:
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t2 = _context.v;
            setLoading(false);
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function initializeVideoSource() {
      return _ref.apply(this, arguments);
    };
  }();
  var initializeStream = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var hlsUrl, hls;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            if (videoRef.current) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2);
          case 1:
            try {
              // Use HLS for better browser compatibility
              hlsUrl = "".concat(process.env.REACT_APP_HLS_BASE_URL || 'http://192.168.16.116:4000', "/stream/hls/stream.m3u8"); // Check if HLS.js is available
              if (window.Hls && window.Hls.isSupported()) {
                hls = new window.Hls({
                  enableWorker: true,
                  lowLatencyMode: true,
                  backBufferLength: 90,
                  liveSyncDurationCount: 1,
                  // Sync to live immediately
                  liveMaxLatencyDurationCount: 2,
                  // Max 2 segments latency
                  liveDurationInfinity: true,
                  // Don't wait for duration
                  liveBackBufferLength: 0 // No back buffer for live
                });
                hls.loadSource(hlsUrl);
                hls.attachMedia(videoRef.current);
                hls.on(window.Hls.Events.MANIFEST_PARSED, function () {
                  setHasCamera(true);
                  setLoading(false);
                });
                hls.on(window.Hls.Events.LEVEL_LOADED, function () {
                  setHasCamera(true);
                  setLoading(false);
                });
                hls.on(window.Hls.Events.ERROR, function (event, data) {
                  if (data.fatal) {
                    switch (data.type) {
                      case window.Hls.ErrorTypes.NETWORK_ERROR:
                        hls.startLoad();
                        break;
                      case window.Hls.ErrorTypes.MEDIA_ERROR:
                        hls.recoverMediaError();
                        break;
                      default:
                        setLoading(false);
                        break;
                    }
                  }
                });
              } else if (videoRef.current.canPlayType('application/vnd.apple.mpegurl')) {
                // Native HLS support (Safari)
                videoRef.current.src = hlsUrl;
                videoRef.current.load();
                videoRef.current.onloadedmetadata = function () {
                  setHasCamera(true);
                  setLoading(false);
                };
                videoRef.current.oncanplay = function () {
                  setHasCamera(true);
                  setLoading(false);
                };
                videoRef.current.onerror = function (e) {
                  setLoading(false);
                };
              } else {
                // Fallback to MJPEG stream
                videoRef.current.src = streamUrl;
                videoRef.current.load();
                videoRef.current.onloadedmetadata = function () {
                  setHasCamera(true);
                  setLoading(false);
                };
                videoRef.current.oncanplay = function () {
                  setHasCamera(true);
                  setLoading(false);
                };
                videoRef.current.onerror = function (e) {
                  setLoading(false);
                };
              }
            } catch (err) {
              setLoading(false);
            }
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function initializeStream() {
      return _ref2.apply(this, arguments);
    };
  }();

  // Call handleShare when QR code step is shown to ensure link is set
  (0, _react.useEffect)(function () {
    if (resultsStep === 1 && !link) {
      handleShare();
    }
  }, [resultsStep]);

  // Cleanup on unmount
  (0, _react.useEffect)(function () {
    return function () {
      if (reconnectTimeoutRef.current) {
        clearTimeout(reconnectTimeoutRef.current);
      }
      if (videoRef.current && videoRef.current.srcObject) {
        var tracks = videoRef.current.srcObject.getTracks();
        tracks.forEach(function (track) {
          return track.stop();
        });
      }
    };
  }, []);
  var capturePhoto = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var response, errorText, result, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            _context3.p = 0;
            _context3.n = 1;
            return fetch("".concat(project.backEndUri, "/capture_obs_frame"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                cell_id: cell.id,
                filter_id: (selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.id) || null,
                filter_name: (selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.name) || null
              })
            });
          case 1:
            response = _context3.v;
            if (response.ok) {
              _context3.n = 3;
              break;
            }
            _context3.n = 2;
            return response.text();
          case 2:
            errorText = _context3.v;
            throw new Error("Backend capture failed: ".concat(response.status, " - ").concat(errorText));
          case 3:
            _context3.n = 4;
            return response.json();
          case 4:
            result = _context3.v;
            if (!result.image_uri) {
              _context3.n = 5;
              break;
            }
            setCapturedImage(result.image_uri); // Use S3 URL directly
            setCurrentDataUri(result.image_uri);
            setLink(result.image_uri);

            // Log the event for analytics
            logEvent('click', {
              cellId: cell.id,
              pageId: page.id,
              languageCode: intl.locale,
              action: 'capture_obs_frame',
              filter_id: selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.id,
              link: result.image_uri
            });
            _context3.n = 6;
            break;
          case 5:
            throw new Error('No image URI returned from backend');
          case 6:
            _context3.n = 8;
            break;
          case 7:
            _context3.p = 7;
            _t3 = _context3.v;
          case 8:
            return _context3.a(2);
        }
      }, _callee3, null, [[0, 7]]);
    }));
    return function capturePhoto() {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleFilterSelect = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(filterId) {
      var filter, response, _t4;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            filter = filterOptions.find(function (f) {
              return f.id === filterId;
            });
            if (filter) {
              _context4.n = 1;
              break;
            }
            return _context4.a(2);
          case 1:
            setSelectedFilter(filter);
            setStep('preview'); // Move to preview step

            // Send filter change to OBS via backend
            _context4.p = 2;
            _context4.n = 3;
            return fetch("".concat(project.backEndUri, "/obs/change-scene"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                scene: filter.obsScene,
                // Keep for backward compatibility
                filterId: filterId
              })
            });
          case 3:
            response = _context4.v;
            if (!response.ok) {
              console.warn('Failed to change OBS scene:', response.statusText);
            } else {
              // Force refresh the video stream to get the new frame
              if (videoRef.current) {
                videoRef.current.load();
                // Additional refresh after a short delay to ensure frame change
                setTimeout(function () {
                  if (videoRef.current) {
                    videoRef.current.load();
                  }
                }, 500);
              }
            }
            _context4.n = 5;
            break;
          case 4:
            _context4.p = 4;
            _t4 = _context4.v;
            console.warn('Error changing OBS scene:', _t4);
          case 5:
            // Video will be initialized when user clicks "Take Picture" button

            // Log the filter selection
            logEvent('click', {
              cellId: cell.id,
              pageId: page.id,
              languageCode: intl.locale,
              action: 'filter_selected',
              filter: filterId
            });
          case 6:
            return _context4.a(2);
        }
      }, _callee4, null, [[2, 4]]);
    }));
    return function handleFilterSelect(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  var startCapture = function startCapture() {
    // Clear any previous captured image before starting new capture
    setCapturedImage(null);
    setLink(null);
    setCurrentDataUri(null);
    setStep('capture');
    setIsInitialized(false); // Reset to allow video initialization
    setLoading(false); // Ensure loading is false to show video immediately

    // Wait 3 seconds for OBS frame to stabilize, then start countdown
    setTimeout(function () {
      setIsCountingDown(true);
      setCount(5);
      var currentCount = 5;
      var countdownInterval = setInterval(function () {
        currentCount--;
        setCount(currentCount);
        if (currentCount <= 0) {
          clearInterval(countdownInterval);
          setIsCountingDown(false);
          // Wait 1 more second for final frame stabilization before capture
          setTimeout(function () {
            capturePhoto();
          }, 1000);
        }
      }, 1000);
    }, 3000); // 3 seconds delay for OBS frame stabilization
  };
  var handleShare = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      var requestBody, response, record, _t5;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            if (capturedImage) {
              _context5.n = 1;
              break;
            }
            console.error('❌ No image to share - capturedImage is null/undefined');
            return _context5.a(2);
          case 1:
            _context5.p = 1;
            requestBody = {
              cell_id: cell.id,
              image: capturedImage,
              // Use the captured image
              email: null // No email for QR code
            }; // Send photo to backend API
            _context5.n = 2;
            return fetch("".concat(project.backEndUri, "/send_photo"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(requestBody)
            });
          case 2:
            response = _context5.v;
            if (response.ok) {
              _context5.n = 3;
              break;
            }
            console.error('❌ API request failed with status:', response.status);
            throw new Error('Upload failed');
          case 3:
            _context5.n = 4;
            return response.json();
          case 4:
            record = _context5.v;
            setLink(record.image_uri);
            _context5.n = 6;
            break;
          case 5:
            _context5.p = 5;
            _t5 = _context5.v;
            console.error('❌ Error in handleShare:', _t5);
            console.error('❌ Error message:', _t5.message);
          case 6:
            return _context5.a(2);
        }
      }, _callee5, null, [[1, 5]]);
    }));
    return function handleShare() {
      return _ref5.apply(this, arguments);
    };
  }();
  var handlePrint = function handlePrint() {
    if (!currentDataUri && !capturedImage && !link) return;

    // Print the current captured image as is
    var imageToPrint = link || capturedImage || currentDataUri;
    console.log(imageToPrint, "image url");
    if (window.electronAPI) {
      console.log("sending it to printer");
      window.electronAPI.sendImageForPrint(imageToPrint);
    }
    if (window.Android && typeof window.Android.postMessage === 'function') {
      window.Android.postMessage(imageToPrint);
    }
    setPrinted(true);
  };
  var resetPhotobooth = function resetPhotobooth() {
    setStep(0);
    setCountdown(3);
    setCapturedImage(null);
    setCurrentDataUri(null);
    setEmail('');
    setEmailSended(false);
    setPrinted(false);
    setStarted(false);
  };

  // Filter selection UI - Simple button layout
  var renderFilterSelection = function renderFilterSelection() {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        position: 'fixed',
        top: 0,
        left: '-21px',
        width: '104vw',
        height: '100vh',
        backgroundImage: "url(".concat(uriTransformer('https://web-treeosk.online/apks/haribo_images/haribo_filter_background.png'), ")"),
        backgroundSize: '100%',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        fontFamily: 'Arial, sans-serif'
      }
    }, /*#__PURE__*/_react.default.createElement("style", null, "                 \n\n                        // #root div:nth-child(2) > div:nth-child(1) > div:nth-child(1) {\n                          \n                        //     height: 100dvh !important;}\n\n                              #root  .react-grid-item.static.cssTransforms {\n                              height: 100dvh !important;\n                              width: 100dvw !important;}\n                     "), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '2rem',
        maxWidth: '800px',
        width: '90%'
      }
    }, filterOptions.map(function (filter) {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: filter.id,
        onClick: function onClick() {
          return handleFilterSelect(filter.id);
        },
        style: {
          background: 'transparent',
          border: 'none',
          borderRadius: '0',
          padding: '0',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          boxShadow: 'none',
          minHeight: '400px',
          display: 'flex',
          flexDirection: 'column',
          // overflow: 'hidden',
          position: 'relative'
        },
        onMouseEnter: function onMouseEnter(e) {
          e.target.style.transform = 'scale(1.05)';
          e.target.style.transition = '0.5s';
        },
        onMouseLeave: function onMouseLeave(e) {
          e.target.style.transform = 'scale(1)';
        }
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: filter.preview,
        alt: "".concat(filter.name, " background"),
        style: {
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          objectPosition: 'center'
        },
        onError: function onError(e) {
          console.error("Failed to load image: ".concat(filter.preview));
          e.target.style.display = 'none';
        }
      }));
    })), selectedFilter && /*#__PURE__*/_react.default.createElement("button", {
      onClick: function onClick() {
        return setShowFilterSelection(false);
      },
      style: {
        background: 'linear-gradient(45deg, #FF0000, #FF6B6B)',
        color: 'white',
        border: 'none',
        padding: '1.2rem 3rem',
        borderRadius: '50px',
        fontSize: '1.4rem',
        fontWeight: 'bold',
        cursor: 'pointer',
        marginTop: '3rem',
        boxShadow: '0 6px 20px rgba(255,0,0,0.4)',
        transition: 'all 0.3s ease',
        textTransform: 'uppercase',
        letterSpacing: '0.1em'
      },
      onMouseEnter: function onMouseEnter(e) {
        e.target.style.transform = 'scale(1.05)';
        e.target.style.transition = '0.5s';
        e.target.style.boxShadow = '0 8px 25px rgba(255,0,0,0.6)';
      },
      onMouseLeave: function onMouseLeave(e) {
        e.target.style.transform = 'scale(1)';
        e.target.style.boxShadow = '0 6px 20px rgba(255,0,0,0.4)';
      }
    }, "Start Photobooth"));
  };

  // Preview screen with selected filter and take picture button
  var renderPreview = function renderPreview() {
    if (!selectedFilter) return null;
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        // background: '#1E3A8A', // Blue background like in the design
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        zIndex: 1000,
        fontFamily: 'Arial, sans-serif'
      }
    }, /*#__PURE__*/_react.default.createElement("button", {
      onClick: function onClick() {
        // Reset everything to fresh state - same as Start Again button
        setCapturedImage(null);
        setLink(null);
        setCurrentDataUri(null);
        setResultsStep(0);
        setStep('filter-selection');
        setSelectedFilter(null);
      },
      style: {
        background: 'transparent',
        border: 'none',
        color: 'white',
        fontSize: '24px',
        cursor: 'pointer',
        padding: '0.5rem',
        position: 'absolute',
        zIndex: '999',
        top: '67px',
        left: '201px'
      }
    }, /*#__PURE__*/_react.default.createElement("svg", {
      width: "56",
      height: "56",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
    }), /*#__PURE__*/_react.default.createElement("polyline", {
      points: "9,22 9,12 15,12 15,22"
    }))), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '48px'
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        position: 'relative'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        position: 'absolute',
        top: 0,
        left: '-21px',
        width: '104vw',
        height: '104vh',
        backgroundImage: 'url(https://web-treeosk.online/apks/haribo_images/haribo_screens_background.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        zIndex: 1
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        position: 'relative',
        // width: '90%',
        // maxWidth: '600px',
        aspectRatio: '4/5',
        // border: '4px solid #FF6B35', // Orange border like in design
        borderRadius: '20px',
        overflow: 'hidden',
        zIndex: 2,
        boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
        width: '926px',
        height: '1420px',
        marginTop: '100px'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundImage: "url(".concat(selectedFilter.preview, ")"),
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        zIndex: 3
      }
    }), /*#__PURE__*/_react.default.createElement("style", null, "                 \n\n                        #root div:nth-child(2) > div:nth-child(1) > div:nth-child(1) {\n                          \n                            height: 100dvh !important;}\n\n                              #root  .react-grid-item.static.cssTransforms {\n                              height: 100dvh !important;\n                              width: 100dvw !important;}\n                     "), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 10,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '1rem'
      }
    }, /*#__PURE__*/_react.default.createElement("button", {
      onClick: startCapture,
      style: {
        background: '#FF0000',
        // Red button like in design
        border: '3px solid white',
        borderRadius: '50%',
        width: '120px',
        height: '120px',
        color: 'white',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
        transition: 'all 0.3s ease'
      },
      onMouseEnter: function onMouseEnter(e) {
        e.target.style.transform = 'scale(1.1)';
      },
      onMouseLeave: function onMouseLeave(e) {
        e.target.style.transform = 'scale(1)';
      }
    }, /*#__PURE__*/_react.default.createElement("svg", {
      style: {
        minWidth: '2rem',
        minHeight: '2rem'
      },
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "lucide lucide-camera-icon lucide-camera"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"
    }), /*#__PURE__*/_react.default.createElement("circle", {
      cx: "12",
      cy: "13",
      r: "3"
    }))), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: 'white',
        fontSize: '1.2rem',
        fontWeight: 'bold',
        textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
        textAlign: 'center'
      }
    }, "Take the picture")))));
  };

  // Captured image preview screen with options
  var renderCapturedPreview = function renderCapturedPreview() {
    if (!capturedImage && !link) return null;
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: '#1E3A8A',
        // Dark blue background
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        position: 'absolute',
        top: '2rem',
        left: '2rem',
        right: '2rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        zIndex: 10
      }
    }, /*#__PURE__*/_react.default.createElement("button", {
      onClick: function onClick() {
        // Reset everything to fresh state - same as Start Again button
        setCapturedImage(null);
        setLink(null);
        setCurrentDataUri(null);
        setResultsStep(0);
        setStep('filter-selection');
        setSelectedFilter(null);
      },
      style: {
        background: 'transparent',
        border: 'none',
        color: 'white',
        fontSize: '24px',
        cursor: 'pointer',
        padding: '0.5rem',
        position: 'absolute',
        zIndex: '999',
        top: '30px',
        left: '150px'
      }
    }, /*#__PURE__*/_react.default.createElement("svg", {
      width: "56",
      height: "56",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
    }), /*#__PURE__*/_react.default.createElement("polyline", {
      points: "9,22 9,12 15,12 15,22"
    }))), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '60px'
      }
    })), /*#__PURE__*/_react.default.createElement("style", null, "                 \n\n                        #root div:nth-child(2) > div:nth-child(1) > div:nth-child(1) {\n                          \n                            height: 100dvh !important;}\n\n                              #root  .react-grid-item.static.cssTransforms {\n                              height: 100dvh !important;\n                              width: 100dvw !important;}\n                     "), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        position: 'absolute',
        top: 0,
        left: '-21px',
        width: '104vw',
        height: '104vh',
        backgroundImage: 'url(https://web-treeosk.online/apks/haribo_images/haribo_screens_background.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        zIndex: 1
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        position: 'relative',
        // width: '90%',
        // maxWidth: '600px',
        aspectRatio: '4/5',
        // Orange border like in design
        borderRadius: '20px',
        overflow: 'hidden',
        zIndex: 2,
        boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
        marginBottom: '2rem',
        width: '840px',
        height: '1288px'
      }
    }, /*#__PURE__*/_react.default.createElement("img", {
      key: link || capturedImage // Force re-render when image changes
      ,

      src: link || capturedImage,
      alt: "Captured Photo",
      style: {
        width: '100%',
        height: '100%',
        objectFit: 'cover'
        // Removed transform: 'scaleX(-1)' - don't mirror the captured image
      }
    })), resultsStep === 0 && /*#__PURE__*/_react.default.createElement("div", {
      style: {
        position: 'absolute',
        bottom: '2rem',
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        zIndex: 10
      }
    }, /*#__PURE__*/_react.default.createElement("button", {
      onClick: function onClick() {
        setResultsStep(1);
      },
      style: {
        background: '#32CD32',
        // Green background
        border: '3px solid white',
        borderRadius: '45px',
        padding: '1rem 3rem',
        fontSize: '1.2rem',
        fontWeight: 'bold',
        color: 'white',
        cursor: 'pointer',
        minWidth: '200px'
      }
    }, "Continue"), /*#__PURE__*/_react.default.createElement("button", {
      onClick: function onClick() {
        setCapturedImage(null);
        setLink(null);
        setCurrentDataUri(null);
        setResultsStep(0);
        setStep('filter-selection');
        setSelectedFilter(null);
      },
      style: {
        background: '#1E3A8A',
        // Dark blue background
        border: 'none',
        borderRadius: '30px',
        padding: '1rem 3rem',
        fontSize: '1.2rem',
        fontWeight: 'bold',
        color: 'white',
        cursor: 'pointer',
        minWidth: '200px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0.5rem',
        fontFamily: FONTS.vag
      }
    }, /*#__PURE__*/_react.default.createElement("svg", {
      width: "20",
      height: "20",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: "M21 3v5h-5"
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: "M3 21v-5h5"
    })), "START AGAIN")), resultsStep === 1 && /*#__PURE__*/_react.default.createElement("div", {
      style: {
        position: 'absolute',
        bottom: '0.5rem',
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '0.5rem',
        zIndex: 10,
        width: '90%',
        maxWidth: '600px'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: 'white',
        fontSize: '1rem',
        fontWeight: 'bold',
        textAlign: 'center',
        textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
        marginBottom: '0rem'
      }
    }, "Print your photo or scan the QR code"), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: '2rem',
        width: '100%',
        justifyContent: 'center'
      }
    }, /*#__PURE__*/_react.default.createElement("button", {
      onClick: handlePrint,
      style: {
        background: 'linear-gradient(45deg, #32CD32, #228B22)',
        border: '3px solid white',
        borderRadius: '25px',
        padding: '1rem 2rem',
        fontSize: '1.2rem',
        fontWeight: 'bold',
        color: 'white',
        cursor: 'pointer',
        minWidth: '200px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0.5rem',
        boxShadow: '0 4px 8px rgba(0,0,0,0.3)'
      }
    }, /*#__PURE__*/_react.default.createElement("svg", {
      width: "20",
      height: "20",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/_react.default.createElement("polyline", {
      points: "6,9 6,2 18,2 18,9"
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: "M6,18H4a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2H20a2,2,0,0,1,2,2v5a2,2,0,0,1-2,2H18"
    }), /*#__PURE__*/_react.default.createElement("rect", {
      x: "6",
      y: "14",
      width: "12",
      height: "8"
    })), "PRINT"), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        background: 'white',
        padding: '0.5rem',
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0,0,0,0.3)'
      }
    }, link ? /*#__PURE__*/_react.default.createElement(_qrcode.QRCodeSVG, {
      value: link,
      size: 150
    }) : /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '150px',
        height: '150px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'white',
        borderRadius: '8px',
        color: '#666',
        fontSize: '12px',
        textAlign: 'center'
      }
    }, "Generating QR Code...")))));
  };

  // Render different steps
  var renderStep = function renderStep() {
    // If we have a captured image or S3 link, show the captured preview screen
    if (capturedImage || link) {
      return renderCapturedPreview();
    }
    switch (step) {
      case 'filter-selection':
        return renderFilterSelection();
      case 'preview':
        return renderPreview();
      case 'capture':
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("style", null, "\n                @keyframes spin {\n                  0% { transform: rotate(0deg); }\n                  100% { transform: rotate(360deg); }\n                }\n              "), /*#__PURE__*/_react.default.createElement("button", {
          onClick: function onClick() {
            // Reset everything to fresh state - same as Start Again button
            setCapturedImage(null);
            setLink(null);
            setCurrentDataUri(null);
            setResultsStep(0);
            setStep('filter-selection');
            setSelectedFilter(null);
          },
          style: {
            background: 'transparent',
            border: 'none',
            color: 'white',
            fontSize: '24px',
            cursor: 'pointer',
            padding: '0.5rem',
            position: 'absolute',
            zIndex: '999',
            top: '67px',
            left: '201px'
          }
        }, /*#__PURE__*/_react.default.createElement("svg", {
          width: "56",
          height: "56",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
        }), /*#__PURE__*/_react.default.createElement("polyline", {
          points: "9,22 9,12 15,12 15,22"
        }))), /*#__PURE__*/_react.default.createElement("div", {
          style: {
            color: 'white',
            fontSize: '2rem',
            fontWeight: 'bold',
            textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
          }
        }, /*#__PURE__*/_react.default.createElement("div", {
          style: {
            width: '48px'
          }
        }), /*#__PURE__*/_react.default.createElement("div", {
          style: {
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '2rem',
            position: 'relative'
          }
        }, /*#__PURE__*/_react.default.createElement("div", {
          style: {
            position: 'absolute',
            top: 0,
            left: '-21px',
            width: '104vw',
            height: '104vh',
            backgroundImage: 'url(https://web-treeosk.online/apks/haribo_images/haribo_screens_background.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            zIndex: 1
          }
        }), /*#__PURE__*/_react.default.createElement("style", null, "                 \n\n                        #root div:nth-child(2) > div:nth-child(1) > div:nth-child(1) {\n                          \n                            height: 100dvh !important;}\n\n                              #root  .react-grid-item.static.cssTransforms {\n                              height: 100dvh !important;\n                              width: 100dvw !important;}\n                     "), /*#__PURE__*/_react.default.createElement("div", {
          style: {
            position: 'relative',
            // width: '90%',
            // maxWidth: '600px',
            aspectRatio: '4/5',
            // border: '4px solid #FF6B35', // Orange border like in design
            borderRadius: '20px',
            overflow: 'hidden',
            zIndex: 2,
            boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
            width: '926px',
            height: '1420px',
            marginTop: '200px'
          }
        }, /*#__PURE__*/_react.default.createElement("video", {
          ref: videoRef,
          style: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          },
          autoPlay: true,
          muted: true,
          playsInline: true,
          controls: false
        }), selectedFilter && /*#__PURE__*/_react.default.createElement("div", {
          style: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundImage: "url(".concat(selectedFilter.image, ")"),
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            zIndex: 3,
            marginTop: '100px'
          }
        }), isCountingDown && count > 0 && /*#__PURE__*/_react.default.createElement("div", {
          style: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 15,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }
        }, /*#__PURE__*/_react.default.createElement("div", {
          style: {
            fontSize: '110px',
            fontWeight: 'bold',
            color: 'white',
            textShadow: '4px 4px 8px rgba(0,0,0,0.8)',
            fontFamily: 'Arial, sans-serif',
            width: '226px',
            height: '226px',
            borderRadius: '50%',
            background: 'rgba(0,0,0,0.5)',
            border: '8px solid white',
            margin: 'auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }
        }, count)), loading && /*#__PURE__*/_react.default.createElement("div", {
          style: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 15,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white'
          }
        }, /*#__PURE__*/_react.default.createElement("div", {
          style: {
            width: '50px',
            height: '50px',
            border: '4px solid rgba(255,255,255,0.3)',
            borderTop: '4px solid white',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            marginBottom: '1rem'
          }
        }), /*#__PURE__*/_react.default.createElement("div", null, "Loading stream..."))))));
      case 0:
        // Camera view - Show stream directly
        return /*#__PURE__*/_react.default.createElement("div", {
          style: {
            position: 'relative',
            width: '100vw',
            height: '100vh',
            background: '#000',
            overflow: 'hidden'
          }
        }, /*#__PURE__*/_react.default.createElement("video", {
          ref: videoRef,
          style: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover'
            // No mirror effect - stream is already mirrored
          },
          autoPlay: true,
          muted: true,
          playsInline: true,
          controls: false
        }), /*#__PURE__*/_react.default.createElement("canvas", {
          ref: canvasRef,
          style: {
            display: 'none'
          }
        }), /*#__PURE__*/_react.default.createElement("div", {
          style: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-end',
            padding: '2rem',
            zIndex: 10
          }
        }, /*#__PURE__*/_react.default.createElement("div", {
          style: {
            display: 'flex',
            gap: '1rem',
            alignItems: 'center'
          }
        }, /*#__PURE__*/_react.default.createElement("button", {
          onClick: function onClick() {
            return setShowFilterSelection(true);
          },
          style: {
            background: 'rgba(255,107,107,0.9)',
            color: 'white',
            border: 'none',
            padding: '1rem 2rem',
            borderRadius: '25px',
            fontSize: '1rem',
            fontWeight: 'bold',
            cursor: 'pointer'
          }
        }, "Change Filter"), /*#__PURE__*/_react.default.createElement("button", {
          onClick: startCapture,
          style: {
            background: 'rgba(255,255,255,0.9)',
            color: '#ff6b6b',
            border: 'none',
            padding: '1rem 2rem',
            borderRadius: '25px',
            fontSize: '1rem',
            fontWeight: 'bold',
            cursor: 'pointer'
          }
        }, "Take Photo"))), loading && /*#__PURE__*/_react.default.createElement("div", {
          style: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            background: 'rgba(0,0,0,0.8)',
            color: 'white',
            padding: '2rem',
            borderRadius: '15px',
            textAlign: 'center',
            zIndex: 20
          }
        }, /*#__PURE__*/_react.default.createElement("div", {
          style: {
            fontSize: '1.2rem',
            marginBottom: '1rem'
          }
        }, "Connecting to video stream..."), /*#__PURE__*/_react.default.createElement("div", {
          style: {
            width: '40px',
            height: '40px',
            border: '4px solid rgba(255,255,255,0.3)',
            borderTop: '4px solid white',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto'
          }
        })));
      case 1:
        // Countdown
        return /*#__PURE__*/_react.default.createElement("div", {
          style: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000
          }
        }, /*#__PURE__*/_react.default.createElement("div", {
          style: {
            fontSize: '8rem',
            color: 'white',
            fontWeight: 'bold',
            textShadow: '4px 4px 8px rgba(0,0,0,0.5)'
          }
        }, countdown));
      case 2:
        // Capture (flash effect)
        return /*#__PURE__*/_react.default.createElement("div", {
          style: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000
          }
        }, /*#__PURE__*/_react.default.createElement("div", {
          style: {
            fontSize: '3rem',
            color: '#ff6b6b',
            fontWeight: 'bold'
          }
        }, "\uD83D\uDCF8"));
      case 3:
        // Results
        return /*#__PURE__*/_react.default.createElement("div", {
          style: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'linear-gradient(135deg, #ff6b6b 0%, #ff8e8e 50%, #ffa8a8 100%)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            padding: '2rem'
          }
        }, capturedImage && /*#__PURE__*/_react.default.createElement("div", {
          style: {
            background: 'white',
            padding: '1rem',
            borderRadius: '20px',
            marginBottom: '2rem',
            boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
          }
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: capturedImage,
          alt: "Captured photo",
          style: {
            maxWidth: '400px',
            maxHeight: '500px',
            borderRadius: '15px'
          }
        })), /*#__PURE__*/_react.default.createElement("div", {
          style: {
            display: 'flex',
            gap: '1rem',
            flexWrap: 'wrap',
            justifyContent: 'center'
          }
        }, /*#__PURE__*/_react.default.createElement("button", {
          onClick: function onClick() {
            return setShowFilterSelection(true);
          },
          style: {
            padding: '15px 30px',
            backgroundColor: 'rgba(255,255,255,0.8)',
            color: '#ff6b6b',
            border: '2px solid white',
            borderRadius: '25px',
            cursor: 'pointer',
            fontSize: '1rem'
          }
        }, "Change Filter"), /*#__PURE__*/_react.default.createElement("button", {
          onClick: handlePrint,
          style: {
            padding: '15px 30px',
            backgroundColor: 'rgba(255,255,255,0.8)',
            color: '#ff6b6b',
            border: '2px solid white',
            borderRadius: '25px',
            cursor: 'pointer',
            fontSize: '1rem'
          }
        }, "Print"), /*#__PURE__*/_react.default.createElement("button", {
          onClick: resetPhotobooth,
          style: {
            padding: '15px 30px',
            backgroundColor: 'rgba(255,255,255,0.8)',
            color: '#ff6b6b',
            border: '2px solid white',
            borderRadius: '25px',
            cursor: 'pointer',
            fontSize: '1rem'
          }
        }, "Take Another")), !emailSended && /*#__PURE__*/_react.default.createElement("form", {
          onSubmit: handleShare,
          style: {
            marginTop: '2rem',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '1rem'
          }
        }, /*#__PURE__*/_react.default.createElement("input", {
          type: "email",
          value: email,
          onChange: function onChange(e) {
            return setEmail(e.target.value);
          },
          placeholder: "Enter your email",
          required: true,
          style: {
            padding: '1rem',
            borderRadius: '25px',
            border: '2px solid white',
            fontSize: '1rem',
            width: '300px',
            textAlign: 'center'
          }
        }), /*#__PURE__*/_react.default.createElement("button", {
          type: "submit",
          style: {
            padding: '1rem 2rem',
            backgroundColor: 'white',
            color: '#ff6b6b',
            border: 'none',
            borderRadius: '25px',
            cursor: 'pointer',
            fontSize: '1rem',
            fontWeight: 'bold'
          }
        }, "Send to Email")), emailSended && /*#__PURE__*/_react.default.createElement("div", {
          style: {
            color: 'white',
            fontSize: '1.2rem',
            marginTop: '1rem',
            textAlign: 'center'
          }
        }, "\u2705 Photo sent to your email!"));
      default:
        return null;
    }
  };

  // Render based on current step
  return renderStep();
}